import CommonCreate from "@/components/common/Create"
import BranchForm from "../forms/BranchForm"
import { useEffect, useState } from "react"
import { branchForm } from "@/utils/objects"
import { SelectedValue } from "@/interface/dataInterface"
import { useUserContext } from "@/context/UserContext"

const BranchCreate = () => {
    const { decodedToken } = useUserContext();
    const [formProp, setFormProp] = useState(branchForm)
    const [selected, setSelected] = useState<SelectedValue[]>([]);
    
      useEffect(() => {
        const ids = selected.map((item) => {
          return item.id
        });
        setFormProp((prev) => {
          return {
            ...prev,
            users_ids: ids,
          };
        });
      }, [selected]);

    return (
        <CommonCreate title="Create new branch" resource="branches" data={{...formProp, settings_id: decodedToken?.settings.id}}>
            <BranchForm 
                mode="create" 
                formProp={formProp} 
                setFormProp={setFormProp}
                otherData={selected}
                setOtherData={setSelected}
            />
        </CommonCreate>
    )
}

export default BranchCreate